import PropTypes from 'prop-types'
import React from 'react'
import { Message } from 'semantic-ui-react'

const errorMessages = {
  login: (
    <>
      <b>Whoops!</b> Incorrect email and password combination.
    </>
  ),
  noLoginMethodAvailable: (
    <>
      <b>Uh oh!</b> something went wrong. Please reach out to our support team for help.
    </>
  ),
  sso: (
    <>
      <b>Hold on!</b> Single sign-on is enforced in your account. Please{' '}
      <a href="/login/sso/">proceed with SSO</a> to login
    </>
  ),
  other: (
    <>
      <b>Uh oh!</b> Something went wrong. Please try again later.
    </>
  ),
}

const Warning = ({
  errorType,
  availableLoginMethods,
  missingMethodsString,
  loginMethodText,
  availableMethodsDisplay,
}) => {
  if (errorType) {
    return (
      <Message negative>
        <div data-robot="login-error">{errorMessages[errorType]}</div>
      </Message>
    )
  }

  if (availableLoginMethods.length) {
    return (
      <Message warning>
        <div>
          <b>Hold on!</b> {missingMethodsString} login {loginMethodText} isn't allowed for your
          account. Please sign in with {availableMethodsDisplay}.
        </div>
      </Message>
    )
  }

  return null
}

Warning.propTypes = {
  errorType: PropTypes.oneOf(['login', 'noLoginMethodAvailable', 'sso', 'other']),
  availableLoginMethods: PropTypes.arrayOf(PropTypes.string),
  missingMethodsString: PropTypes.string,
  loginMethodText: PropTypes.string,
  availableMethodsDisplay: PropTypes.string,
}

Warning.defaultProps = {
  availableLoginMethods: [],
}

export default Warning



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Login/Warning/index.js